import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from './axiosBaseQuery'
import {IClientFirm, IDropdownOption} from "../types/types";
import {UtilService} from '@xal3xfx/react-utils'


interface ClientFirmsResponse {
    tableData: IClientFirm[]
    clientFirmDropdownOptions: IDropdownOption[]
}

export const clientFirmsApi = createApi({
    reducerPath: 'clientFirmsApi',
    baseQuery: axiosBaseQuery(),
    tagTypes: ['ClientFirms'],
    refetchOnFocus: false,
    refetchOnReconnect: false,
    endpoints: (builder) => ({
        getAllClientFirms: builder.query<ClientFirmsResponse, void>({
            query: () => ({
                url: '/clientfirms/',
                method: 'GET',
                data: {isSWR: true}
            }),
            transformResponse: (response: IClientFirm[]) => {
                const parsed = UtilService.generateDropdownOptionsFromData<IClientFirm>(
                    response,
                    'clientFirmName',
                    'clientFirmName'
                )

                return {
                    tableData: response,
                    clientFirmDropdownOptions: parsed
                }
            },

            providesTags: ['ClientFirms'],

            // Optional: auto-refetch every 30 seconds
            // pollingInterval: 30000,
        }),
    })
})

export const { useGetAllClientFirmsQuery } = clientFirmsApi
